import graphql__d6991f003b108e1b61d1 from "./__generated__/useCurrentAppQuery.graphql.ts";/* eslint-disable relay/unused-fields */

import graphql from 'babel-plugin-relay/macro'
import { useEffect } from 'react'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { useParams } from 'react-router-dom'
import { invariant } from 'utils'

import { useCurrentAppQuery } from './__generated__/useCurrentAppQuery.graphql'

//TODO: extract user information into a fragment
const query = graphql__d6991f003b108e1b61d1

type UserData = {
  id: string
  firstName?: string | null
  lastName?: string | null
  email: string
  imageUrl?: string | null
}

/** This hook fetches the current organization application and returns the object
 * with frequently used information, such as organization ID and slug, app ID and slug, viewer ID. */
const useCurrentApp = (
  appId: string,
): {
  organizationId: string | null
  viewerId?: string
  appName?: string
  user: UserData
  members: UserData[]
  issueId: string | undefined
  appSlug: string
  organizationSlug: string | undefined
  tenantId: string
} => {
  const params = useParams<{
    issueId: string | undefined
  }>()
  const { viewer } = useLazyLoadQuery<useCurrentAppQuery>(query, { appId })
  const defaultResult = {
    issueId: params?.issueId,
    appSlug: viewer.appById!.slug,
    organizationSlug:
      viewer.appById?.tenant.__typename === 'Organization'
        ? viewer.appById.tenant.slug
        : undefined,
    tenantId:
      viewer.appById?.tenant.__typename === 'Organization' ||
      viewer.appById?.tenant.__typename === 'User'
        ? viewer.appById?.tenant.id
        : '',
  }

  const organizationId =
    viewer.appById?.tenant.__typename === 'Organization'
      ? viewer?.appById?.tenant?.id
      : null
  const appName = viewer?.appById?.name
  const viewerId = viewer.me!.id
  const isSuperAdmin = viewer?.me?.isSuperAdmin
  const members: UserData[] =
    viewer.appById?.tenant.__typename === 'Organization'
      ? (viewer?.appById?.tenant.members || []).map((member) => member.user)
      : ([viewer.me] as UserData[])

  useEffect(() => {
    invariant(!!viewerId, 'Viewer is not found')
    invariant(!!organizationId || isSuperAdmin, 'Organization is not found') // UNIMPLEMENTED issues support for user owned apps
    invariant(!!appId || isSuperAdmin, 'Application is not found')
  }, [viewerId, appId, isSuperAdmin, organizationId])

  return {
    organizationId,
    viewerId,
    appName,
    user: {
      id: viewerId,
      firstName: viewer?.me?.firstName,
      lastName: viewer?.me?.lastName,
      email: viewer.me!.email,
      imageUrl: viewer?.me?.imageUrl,
    },
    members,
    ...defaultResult,
  }
}

export default useCurrentApp
